import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Newspaper, Clock, ArrowRight } from "lucide-react";
import { timeAgo } from "@/components/NewsCard";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const StacksNewsFrame = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    axios.get(`${API}/news`, { params: { category: "stacks", limit: 20 } })
      .then((r) => setItems(r.data.items || [])).catch(() => {});
  }, []);

  return (
    <section className="px-6 pb-12" data-testid="home-stacks-news">
      <div className="max-w-7xl mx-auto rounded-2xl border border-white/10 bg-white/[0.02]">
        <div className="flex items-center gap-2 border-b border-white/10 px-5 py-4">
          <Newspaper className="h-5 w-5 text-primary" />
          <h2 className="font-heading text-base md:text-lg tracking-wider">STX & STACKS NEWS</h2>
        </div>
        <div className="max-h-[360px] overflow-y-auto divide-y divide-white/5" data-testid="home-stacks-news-scroll">
          {items.map((it) => (
            <Link key={it.slug} to={`/news/${it.slug}`} data-testid={`home-news-item-${it.slug}`}
              className="block px-5 py-4 hover:bg-primary/[0.05] transition-colors">
              <div className="flex items-center gap-2 text-[11px] font-mono uppercase text-muted-foreground">
                <span className="truncate max-w-[12rem]">{it.source}</span><span>•</span>
                <span className="inline-flex items-center gap-1"><Clock className="h-3 w-3" />{timeAgo(it.published_at)}</span>
              </div>
              <p className="mt-1.5 font-semibold leading-snug text-white">{it.title}</p>
            </Link>
          ))}
          {items.length === 0 && <p className="px-5 py-6 text-sm text-muted-foreground">Loading latest Stacks news…</p>}
          <Link to="/news" data-testid="home-news-more-link"
            className="flex items-center justify-center gap-2 px-5 py-4 font-mono text-sm font-semibold uppercase text-primary hover:bg-primary/[0.08] transition-colors">
            News <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </section>
  );
};
